export const selectFormAppointment = (state) => state.caseForms.caseForms?.formAppointment;
export const selectFormDocumentation= (state) => state.caseForms.caseForms?.formDocumentation;
export const selectFormClaims = (state) => state.caseForms.caseForms?.formClaims;
export const selectFormInformation = (state) => state.caseForms.caseForms?.formInformation;
export const selectFormTerminations = (state) => state.caseForms.caseForms?.formTerminations;
export const selectFormSubstitutionVehicle = (state) => state.caseForms.caseForms?.formSubstitutionVehicle;
export const selectFormDelivery = (state) => state.caseForms.caseForms?.formDelivery;
export const selectFormOvc = (state)=> state.caseForms.caseForms?.formOvc;
export const selectFormItv = (state)=> state.caseForms.caseForms?.formItv;
export const selectFormFuelCard = (state)=> state.caseForms.caseForms?.formFuelCard;
export const selectFormMarsh = (state)=> state.caseForms.caseForms?.formMarsh
export const selectFormLetterQuery = (state)=> state.caseForms.caseForms?.formLetterQuery
export const selectFormResidentCard = (state)=> state.caseForms.caseForms?.formResidentCard

export const selectFormTest = (state)=> state.caseForms.caseForms?.formTest;
